<ion-app>
  <app-header
    *ngIf="router.url === '/create-dull' || router.url === '/dull-list' || router.url.includes('/dull-gallery')"></app-header>
  <ion-router-outlet></ion-router-outlet>
  <app-spinner></app-spinner>
</ion-app>